import React from 'react'
import { Trans } from '@lingui/react/macro'

import { useLocation } from 'react-router-dom'

import { StackProps, YStack } from 'tamagui'
import { H2, H3, Text, Paragraph, Strong } from '../Text'
import { Link } from '../Link'
import { Card } from '../Card'

export const NoEventsPlaceholder = (props: StackProps) => {
  const location = useLocation()

  return (
    <YStack {...props} padding='$8' gap='$4' alignItems='center' data-nosnippet>
      <H3 textAlign='center'>
        <Trans>Looks like you got to the bottom!</Trans>
      </H3>

      <Paragraph textAlign='center'>
        <Trans>Couldn&apos;t find what you&apos;re looking for?</Trans>
      </Paragraph>

      <Paragraph textAlign='center'>
        <Trans>
          <Link
            href='/events/new'
            options={{
              state: {
                backgroundLocation:
                  location.state?.backgroundLocation || location,
              },
            }}
          >
            Host an event
          </Link>{' '}
          to share your passion!
        </Trans>
      </Paragraph>
    </YStack>
  )
}

export default NoEventsPlaceholder
